<script>
    export default {
        methods: {
            getListClass(blockView, isListItem) {
                if (blockView) {
                    if (isListItem) {
                        return 'eventlist-item--small is-6-tablet column is-4-desktop'
                    } else {
                        return 'eventlist-item--small'
                    }
                }
                return ''
            },
            // Get the class from button availibility orderstatus
            buttonStatusClass(status) {
                //NotSet = 0,
                //Available = 1,
                //SoldOut = 2,
                //Cancelled = 3,
                //LastTickets = 4
                switch (status) {
                    case "0":
                        return "";
                        break;
                    case "1":
                        return "";
                        break;
                    case "2":
                        return "is-theatre";
                        break;
                    case "3":
                        return "disabled";
                        break;
                    case "4":
                        return "is-theatre";
                        break;
                    default:
                        return "";
                }
            },
            toMediaQuery(mediaString) {
                if (!mediaString) return '';
                return mediaString.split('"')[1];
            },
            reverse(array) {
                return [...array].reverse();
            },
            toGenreString(genreArray) {
                if (!genreArray || !genreArray.length) return '';
                return genreArray.map(genre => genre.name).join(' | ');
            },
            isLesson(item) {
                if (!item || !item.agendaItemType) return false;
                return item.agendaItemType === 'Lesson';
            },
            isEvent(item) {
                if (!item || !item.agendaType) return false;
                return item.agendaType === 'Event';
            },
            isCourse(item) {
                if (!item || !item.agendaType) return false;
                return item.agendaType === 'Course';
            },
            // Simple day string handler for date.
            toDayStr(dateString) {
                return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short' });
            },
            // Simple short date string handler for date.
            toShortDateStr(dateString) {
                return new Date(dateString).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '');
            },
            stripHtml(htmlString) {
                return htmlString.replace(/(<([^>]+)>)/gi, "");
            },
            truncateHtml(htmlString) {
                let strippedString = this.stripHtml(htmlString);
                if (strippedString.length < 160) return strippedString
                return strippedString.replace(/^(.{160}[^\s]*).*/, "$1").trim() + '&hellip;'
            }
        },
        props: [
            'item',
            'blockview',
            'isListItem',
            'continuousLabel',
            'readmoreLabel',
            'orderparam'
        ]
    }
</script>
<template>
    <div :class="['eventlist-item', getListClass(blockview, isListItem), 'eventlist-item--' + item.agendaType.toLowerCase()]">
        <a :href="item.detailUrl" class="eventlist-item-link is-flex">
            <time :class="['eventlist-item-date', 'circle', 'circle--date', blockview ? 'circle--date--small' : '']" :datetime="item.firstStartDate">
                <span class="circle-content">
                    <template v-if="isLesson(item) || (isCourse(item) && item.isContinuous)">
                        <small>{{continuousLabel}}</small>
                    </template>
                    <template v-else>
                        <template v-if="item.children.length > 1">
                            <span class="circle--date-datemulti">{{ item.dateTextTop }}</span>
                            <span class="circle--date-text">{{ item.dateTextMiddle }}</span>
                            <span class="circle--date-datemulti">{{ item.dateTextBottom }}</span>
                        </template>
                        <template v-else>
                            <span class="circle--date-day">{{ item.dateTextTop }}</span>
                            <span class="circle--date-date">{{ item.dateTextBottom }}</span>
                        </template>
                    </template>
                </span>
            </time>
            <div :class="['eventlist-item-container', item.children.length > 1 ? 'eventlist-item-container-noOrder' : '']">
                <picture v-if="item.imageSets && item.imageSets.length && item.imageSets[0].images.length" class="image">
                    <template v-for="format in reverse(item.imageSets[0].images)" :key="format.webPUrl">
                        <source type="image/webp" :srcset="format.webPUrl" :sizes="format.displayWidth + 'px'" :media="toMediaQuery(format.mediaQuery)" />
                        <source :srcset="format.jpegUrl" :sizes="format.displayWidth + 'px'" :media="toMediaQuery(format.mediaQuery)" />
                    </template>
                    <img :src="item.imageSets[0].images[0].defaultCropUrlJpeg" :width="item.imageSets[0].images[0].displayWidth" :height="item.imageSets[0].images[0].webPUrl.match(/height=(\d+)/)[1]" :alt="item.imageSets[0].alias" loading="lazy">
                </picture>
                <picture v-else class="image image-empty"></picture>
                <div class="eventlist-item-info">
                    <div v-if="isEvent(item)" class="eventlist-item-titleContainer is-flex is-justify-content-space-between is-flex-wrap-wrap">
                        <span v-if="item.name" class="eventlist-item-artist title h3 is-3 has-text-weight-bold">{{ item.name }}</span>
                        <span v-if="item.productionLocation.length && item.productionLocation[0].name" class="eventlist-item-location">{{ item.productionLocation[0].name }}</span>
                    </div>
                    <span v-if="isCourse(item) && item.name" class="eventlist-item-course title h3 is-3 has-text-weight-bold">{{ item.name }}</span>
                    <span v-if="item.subtitle" class="eventlist-item-eventTitle title h3 is-3">{{ item.subtitle }}</span>
                    <span v-if="item.intro.length" class="eventlist-item-intro" v-html="truncateHtml(item.intro)"></span>
                    <span v-else class="eventlist-item-intro" v-html="truncateHtml(item.description)"></span>
                    <span v-if="isEvent(item) && item.genres && item.genres.length" class="eventlist-item-genre">{{ toGenreString(item.genres) }}</span>
                    <div v-if="isCourse(item) || item.children.length > 1" class="eventlist-item-buttonContainer is-flex is-justify-content-space-between is-flex-wrap-wrap">
                        <span v-if="item.courseTypes && item.courseTypes.length" class="eventlist-item-genre">{{ toGenreString(item.courseTypes) }}</span>
                        <span class="button is-outlined">{{readmoreLabel}}</span>
                    </div>
                </div>
            </div>
        </a>
        <template v-if="isEvent(item) && item.orderButton && item.availability && item.children.length === 1">
            <template v-if="item.orderButton.isClickable">
            <a v-if="item.orderButton.orderUrlIsOverruled" :href="item.orderButton.url" :class="['button', 'is-orderbutton', 'is-solid', buttonStatusClass(item.orderButton.status)]"> {{item.orderButton.text}}</a>
            <a v-else :href="item.detailUrl + '?' + orderparam + '=' + item.availability.id" :class="['button', 'is-orderbutton', 'is-solid', buttonStatusClass(item.orderButton.status)]">{{item.orderButton.text}}</a>
            </template>
            <span v-else class="button is-orderbutton is-solid disabled">{{item.orderButton.text}}</span>
        </template>
    </div>
</template>
